import { render } from "./BackofficeLayout.vue?vue&type=template&id=5b3e1d4e"
import script from "./BackofficeLayout.vue?vue&type=script&lang=js"
export * from "./BackofficeLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__